// @ts-ignore untyped import
import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
const initialState = {};
export default handleActions({
  [ActionTypes.MEETING_CREATE_FAILED](requestStatus, action) {
    return Object.assign({}, requestStatus, {
      meetingCreate: action.payload.error
    });
  },
  [ActionTypes.MEETING_RESCHEDULE_FAILED](requestStatus, action) {
    return Object.assign({}, requestStatus, {
      meetingReschedule: action.payload.error
    });
  },
  [ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED](requestStatus, action) {
    return Object.assign({}, requestStatus, {
      publicAvailabilityInfoFetch: action.payload.error
    });
  },
  [ActionTypes.MEETING_CANCEL_FAILED](requestStatus, action) {
    return Object.assign({}, requestStatus, {
      meetingCancel: action.payload.error
    });
  }
}, initialState);